namespace h5_vm {

   import IQService = angular.IQService;
   import VmProvisioningPageService = h5_vm.VmProvisioningPageService;
   import VmProvisioningPage = h5_vm.VmProvisioningPageModel;
   import VmProvisioningWizardPage = h5_vm.VmProvisioningWizardPage;

   export class VmProvisioningDeploymentOptionsPageService implements VmProvisioningPageService {

      static $inject: string[] = [
         "i18nService",
         "vuiConstants",
         "vmVuiWizardPageBuilder",
         "vmProvisioningDeploymentOptionsPageModel"
      ];

      constructor(
         private i18nService: any,
         private vuiConstants: any,
         private vmVuiWizardPageBuilder: any,
         private vmProvisioningDeploymentOptionsPageModel: any) {}

      public build(wizardScope: any): VmProvisioningWizardPage {
         let pageModel = new this.vmProvisioningDeploymentOptionsPageModel(
               wizardScope.vmParams,
               wizardScope.wizardViewData);

         wizardScope.vmProvisioningDeploymentConfigPageModel = pageModel;

         return this.vmVuiWizardPageBuilder.buildVuiWizardPage(
            wizardScope.config,
            {
               title: this.i18nService.getString("Common", "DeploymentOptions.title"),
               description: this.i18nService.getString("Common", "DeploymentOptions.description"),
               contentUrl: "vm-ui/resources/vm/views/createVmWizard/deployOvfPages" +
               "/vmProvisioningDeploymentOptions/vm-provisioning-deployment-options.html",
               model: pageModel,
               defaultState: this.vuiConstants.wizard.pageState.SKIPPED
            }
         );
      }
   }

   angular.module("com.vmware.vsphere.client.vm")
      .service("VmProvisioningDeploymentOptionsPageService", VmProvisioningDeploymentOptionsPageService);

}
